export function getIbanValue(iban, opts) {
  return (iban || '').replace(opts?.ibanSymbol || '', '');
  // let res = _iban; if (opts?.freezeSymbol && opts?.ibanSymbol) res = _iban; if (!opts?.freezeSymbol && opts?.ibanSymbol) res = opts?.ibanSymbol + _iban; return res;
}

export function submitIbanValue(iban, opts) {
  // فقط برای جلوگیری از این ک یوزر دستی دوباره سمبل اول شبارو نزده باشه.
  // clean it
  const _iban = (iban || '').replace(opts?.ibanSymbol || '', '');
  let res = _iban;
  if (opts?.freezeSymbol && opts?.ibanSymbol) res = opts?.ibanSymbol + _iban;
  if (!opts?.freezeSymbol && opts?.ibanSymbol) res = iban;
  // console.log(opts?.freezeSymbol && opts?.ibanSymbol && submit, opts?.ibanSymbol + _iban, res);
  return res;
}
